import { Box } from "@chakra-ui/react";

export default function Page({ children }: { children: any }): JSX.Element {
    return (
        <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
            {children}
        </Box>
    )
}